import React, {useEffect, useState} from 'react';
import {useTranslate} from 'react-admin';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import FunctionsIcon from '@mui/icons-material/Functions';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import {d4UrlRest} from "./Env";
import {hasRole, ROLES} from './permissions';
import {useAuth} from 'react-oidc-context';


// import { Card, CardContent, CardHeader } from "@mui/material";
//
// export const Dashboard = () => (
//     <Card>
//         <CardHeader title="Welcome to the administration" />
//         <CardContent>Lorem ipsum sic dolor amet...</CardContent>
//     </Card>
// );


// const fetchBackendVersion = async () => {
//     try {
//         const response = await fetch(d4UrlRest + '/prot_version');
//         const data = await response.json();
//         return data.version;
//     } catch (error) {
//         console.error('Error with Backend-Version:', error);
//         return 'no backend version';
//     }
// };


const styles =
    {
        media: {
            // background-size: 'auto',
            // paddingTop: '56.25%',
            // width: '30%',
            paddingTop: '5%',
            // opacity: '0.1',
            // height: '10%',
            margin: '0',
            top: '0',
            width: '100%',
            height: '100%',
        },
        text: {
            paddingTop: '0%',
            opacity: '1.0',
            // color: 'black',
            paddingRight: '16px',
            paddingBottom: '16px',
            paddingLeft: '16px',
        },
        version: {
            opacity: '0.3',
            // color: 'black',
            paddingTop: '0px',
            paddingRight: '16px',
            paddingBottom: '0px',
            paddingLeft: '16px',
        }
    };

function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
}

export const Dashboard = ({authProvider}) => {
        const translate = useTranslate();
        const [backendVersion, setBackendVersion] = useState('loading...');
        const [permissions, setPermissions] = useState([]);
        const [permissionsLoaded, setPermissionsLoaded] = useState(false);
        const auth = useAuth();

        const fetchBackendVersion = async () => {
            try {
                const headers = new Headers({
                    'Accept': 'application/json',
                });

                // Add authentication token if available
                if (auth.isAuthenticated && auth.user?.access_token) {
                    headers.set('Authorization', `Bearer ${auth.user.access_token}`);
                }

                const response = await fetch(d4UrlRest + '/prot_version', {
                    method: 'GET',
                    headers: headers
                });

                const data = await response.json();
                return data.version;
            } catch (error) {
                // console.error('Error with Backend-Version:', error);
                return 'no backend version';
            }
        };


        // Check if user has product access
        useEffect(() => {
            if (authProvider) {
                authProvider.getPermissions()
                    .then(perms => {
                        setPermissions(perms);
                        setPermissionsLoaded(true);
                    })
                    .catch(() => setPermissionsLoaded(true));
            }
        }, [authProvider]);


        useEffect(() => {
            fetchBackendVersion().then(setBackendVersion);
        }, []);

        return (
            <Card>
                <CardMedia
                    image="/Main_D4c_white2.jpg"
                    title=""
                    style={styles.media}>
                    <CardHeader title="d4"/>
                    {/*<CardHeader title="d3 - distributed data driven inventory and configuration"/>*/}
                    <List component="nav" aria-label={translate('navigation.label')}>

                        {permissionsLoaded &&
                            hasRole(permissions, [ROLES.d5_nodes_priv,
                                ROLES.d5_nodes_ro,
                                ROLES.d5_nodes_rw]) && (
                                <ListItemLink href="products">
                                    <ListItemIcon>
                                        <DeveloperBoardIcon/>
                                        <Typography variant="body1" style={styles.text}>
                                            {translate('resources.products.name')}
                                        </Typography>
                                    </ListItemIcon>
                                    <ListItemText>
                                        <Typography variant="body1" style={styles.text}>
                                            {translate('resources.products.description')}
                                        </Typography>
                                    </ListItemText>
                                </ListItemLink>
                            )}

                        {permissionsLoaded &&
                            hasRole(permissions, [ROLES.d5_nodes_priv,
                                ROLES.d5_nodes_ro,
                                ROLES.d5_nodes_rw]) && (
                                <ListItemLink href="functions">
                                    <ListItemIcon>
                                        <FunctionsIcon/>
                                        <Typography variant="body1" style={styles.text}>
                                            {translate('resources.functions.name')}
                                        </Typography>
                                    </ListItemIcon>
                                    <ListItemText>
                                        <Typography variant="body1" style={styles.text}>
                                            {translate('resources.functions.description')}
                                        </Typography>
                                    </ListItemText>
                                </ListItemLink>
                            )}

                        {permissionsLoaded &&
                            hasRole(permissions, [ROLES.d5_nodes_priv,
                                ROLES.d5_nodes_ro,
                                ROLES.d5_nodes_rw]) && (
                                <ListItemLink href="locations">
                                    <ListItemIcon>
                                        <LocationCityIcon/>
                                        <Typography variant="body1" style={styles.text}>
                                            {translate('resources.locations.name')}
                                        </Typography>
                                    </ListItemIcon>
                                    <ListItemText>
                                        <Typography variant="body1" style={styles.text}>
                                            {translate('resources.locations.description')}
                                        </Typography>
                                    </ListItemText>
                                </ListItemLink>
                            )}

                        {permissionsLoaded &&
                            hasRole(permissions, [ROLES.d5_nodes_priv,
                                ROLES.d5_nodes_ro,
                                ROLES.d5_nodes_rw]) && (
                                <ListItemLink href="organisations">
                                    <ListItemIcon>
                                        <AccountTreeIcon/>
                                        <Typography variant="body1" style={styles.text}>
                                            {translate('resources.organisations.name')}
                                        </Typography>
                                    </ListItemIcon>
                                    <ListItemText>
                                        <Typography variant="body1" style={styles.text}>
                                            {translate('resources.organisations.description')}
                                        </Typography>
                                    </ListItemText>
                                </ListItemLink>
                            )}
                    </List> {/*<Divider/>*/}

                    {/*<List component="nav" aria-label="main mailbox folders">*/}
                    {/*    <ListItemLink href="#/products?displayedFilters={%22ddd_type_id%22%3Atrue}">*/}
                    {/*        <ListItemIcon>*/}
                    {/*            <Typography variant="body1" style={styles.text}>*/}
                    {/*                Filter: "dddType"*/}
                    {/*            </Typography>*/}
                    {/*        </ListItemIcon>*/}
                    {/*        <ListItemText>*/}
                    {/*            <Typography variant="body1" style={styles.text}>*/}
                    {/*                The filter "dddType" selects all objects of a special type, e.g. Application server.*/}
                    {/*            </Typography>*/}
                    {/*        </ListItemText>*/}
                    {/*    </ListItemLink>*/}

                    {/*    <ListItemLink href="#/products?displayedFilters={%22scope_id%22%3Atrue}">*/}
                    {/*        <ListItemIcon>*/}
                    {/*            <Typography variant="body1" style={styles.text}>*/}
                    {/*                Filter: "Scope"*/}
                    {/*            </Typography>*/}
                    {/*        </ListItemIcon>*/}
                    {/*        <ListItemText>*/}
                    {/*            <Typography variant="body1" style={styles.text}>*/}
                    {/*                The "Scope" filter selects all objects from one origin, such as all VMware objects (but then*/}
                    {/*                all different types "dddType")*/}
                    {/*            </Typography>*/}
                    {/*        </ListItemText>*/}
                    {/*    </ListItemLink>*/}


                    {/*    <ListItemLink href="#/products?displayedFilters={%22report_vm_os_id%22%3Atrue}">*/}
                    {/*        <ListItemIcon>*/}
                    {/*            <Typography variant="body1" style={styles.text}>*/}
                    {/*                Filter: "VM OS"*/}
                    {/*            </Typography>*/}
                    {/*        </ListItemIcon>*/}
                    {/*        <ListItemText>*/}
                    {/*            <Typography variant="body1" style={styles.text}>*/}
                    {/*                The "VM OS" filter selects the objects with the searched OS from all VMs.*/}
                    {/*            </Typography>*/}
                    {/*        </ListItemText>*/}
                    {/*    </ListItemLink>*/}

                    {/*    <ListItemLink href="#/products?displayedFilters={%22query_ip%22%3Atrue}">*/}
                    {/*        <ListItemIcon>*/}
                    {/*            <Typography variant="body1" style={styles.text}>*/}
                    {/*                Filter: "IP"*/}
                    {/*            </Typography>*/}
                    {/*        </ListItemIcon>*/}
                    {/*        <ListItemText>*/}
                    {/*            <Typography variant="body1" style={styles.text}>*/}
                    {/*                The filter "IP" selects the objects with a searched IP address (is not yet fully implemented).*/}
                    {/*            </Typography>*/}
                    {/*        </ListItemText>*/}
                    {/*    </ListItemLink>*/}

                    {/*    <ListItemLink href="#/products?displayedFilters={%22query_fqdn%22%3Atrue}">*/}
                    {/*        <ListItemIcon>*/}
                    {/*            <Typography variant="body1" style={styles.text}>*/}
                    {/*                Filter: "FQDN"*/}
                    {/*            </Typography>*/}
                    {/*        </ListItemIcon>*/}
                    {/*        <ListItemText>*/}
                    {/*            <Typography variant="body1" style={styles.text}>*/}
                    {/*                The filter "FQDN" selects the objects with a 'fully qualified domain name' (not yet fully implemented).*/}
                    {/*            </Typography>*/}
                    {/*        </ListItemText>*/}
                    {/*    </ListItemLink>*/}

                    {/*    <ListItemLink href="#/products?displayedFilters={%22report_power_state_id%22%3Atrue}">*/}
                    {/*        <ListItemIcon>*/}
                    {/*            <Typography variant="body1" style={styles.text}>*/}
                    {/*                Filter: "Power State"*/}
                    {/*            </Typography>*/}
                    {/*        </ListItemIcon>*/}
                    {/*        <ListItemText>*/}
                    {/*            <Typography variant="body1" style={styles.text}>*/}
                    {/*                The filter "Power State" selects the VMware VMs with the searched "Power State".*/}
                    {/*            </Typography>*/}
                    {/*        </ListItemText>*/}
                    {/*    </ListItemLink>*/}

                    {/*    <ListItemLink href="#/products?displayedFilters={%22query%22%3Atrue}">*/}
                    {/*        <ListItemIcon>*/}
                    {/*            <Typography variant="body1" style={styles.text}>*/}
                    {/*                Filter: "Fulltext"*/}
                    {/*            </Typography>*/}
                    {/*        </ListItemIcon>*/}
                    {/*        <ListItemText>*/}
                    {/*            <Typography variant="body1" style={styles.text}>*/}
                    {/*                The "Fulltext" filter selects all objects in which the search text is contained in any parameter. (Conceptually, this is not the fastest search ;-))*/}
                    {/*            </Typography>*/}
                    {/*        </ListItemText>*/}
                    {/*    </ListItemLink>*/}
                    {/*</List>*/}
                    {/*<Divider/>*/}
                    {/*<Typography variant="caption" style={styles.text}>*/}
                    {/*    All filters can be combined with each other. Some combinations are of course nonsense.*/}
                    {/*</Typography>*/}
                    {/*<Typography variant="caption" style={styles.text}>*/}
                    {/*    You can find more filters under "ADD FILTER".*/}
                    {/*</Typography>*/}
                    <CardContent>
                        <Typography variant="caption" style={styles.version}>
                            Frontend Vers. 25.4.1beta | Backend Vers. {backendVersion}
                        </Typography>
                    </CardContent>
                </CardMedia>
            </Card>
        );
    }
;
